
__webpack_require__.remotesLoadingData = { chunkMapping: {"5513":["28192"]}, moduleIdToRemoteDataMapping: {"28192":{"shareScope":"default","name":"./module","externalModuleId":72522,"remoteName":"marketplace_ui"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
